const imageLoadingTexts = [
    "Loading image",
    "It should be here somewhere",
    "Framing picture",
    "Enhancing",
    "Dusting off image",
    "This one might take a while",
    "Summoning artwork",
    "Hunting down the image",
    "Almost there",
    "Take in the moment while this loads",
    "You blinked",
    "Don't look it might be shy"
  ];
  
  export default imageLoadingTexts;